import {roleSystemRoute} from './route_utilities'
import Languages from '../../views/languages/Languages.vue'
import CreateLanguage from '../../views/languages/CreateLanguage.vue'
import Language from '../../views/languages/Language.vue'

export const languages =  {
      path: 'languages',
      name: 'Languages',
      component: Languages,
      beforeEnter : roleSystemRoute,
      meta: {
          title: "diller",
          domain:"languages",
          accessroles:["admin","planner","auditor"],
        },
      }

export const create_language = {
      path: 'language',  
      name: 'CreateLanguage',
      component: CreateLanguage,
      meta: {
          title: "yeni_dil",
          preloader:true,
          domain:"languages",
          accessroles:["admin","planner","auditor"],
        },
      }


export const language =
      {
      path: 'language/:id',  
      name: 'Language',
      component: Language,
      meta: {
          title: "dil",
          preloader:true,
          domain:"languages"
        },
      }
